import { KnowledgeCatalog } from "../knowledge/KnowledgeGraph";
import type { KnowledgeNode } from "../knowledge/KnowledgeGraph";

export class KnowledgeContentError extends Error {}

/** Builds the knowledge catalog from parsed `content/knowledge.json` — never hardcoded in TS. */
export function loadKnowledgeCatalog(data: unknown): KnowledgeCatalog {
  if (!Array.isArray(data)) throw new KnowledgeContentError("knowledge.json must be an array");
  const catalog = new KnowledgeCatalog();
  for (const raw of data) {
    if (typeof raw !== "object" || raw === null) throw new KnowledgeContentError("Invalid knowledge node entry");
    const node = raw as Record<string, unknown>;
    if (typeof node["id"] !== "string" || typeof node["title"] !== "string" || typeof node["summary"] !== "string") {
      throw new KnowledgeContentError(`Knowledge node missing id/title/summary: ${JSON.stringify(raw)}`);
    }
    catalog.register({
      id: node["id"],
      title: node["title"],
      summary: node["summary"],
      links: Array.isArray(node["links"]) ? (node["links"] as string[]) : [],
      ...(typeof node["ageLevel"] === "number" ? { ageLevel: node["ageLevel"] } : {}),
    } satisfies KnowledgeNode);
  }
  return catalog;
}
